module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1560"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "C1561a"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_Acknowle#page_xi"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07__Write_t#page_1"
    }
  }, [_vm._v("“Write to Your Unknown Friends”")])]), _vm._v(" "), _c('p', {
    staticClass: "C1557"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/html/08_1__From#page_3"
    }
  }, [_vm._v("1. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSE TO")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1559"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_It_s_Har#page_5"
    }
  }, [_vm._v("It’s Hard to Know Where to Begin")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_From_Our#page_6"
    }
  }, [_vm._v("From Our House to Your House")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_Growing#page_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing Up in a Small Town")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_Easter_#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter, 1948")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_Hands#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_Ridl_Was#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ridl Was Once Spelled Hridl")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_A_Midsum#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Midsummer Night’s Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_My_Fathe#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Father Was in Love with Peggy Lee")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Open_to#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open to the Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_The_Step#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Steps of Pittsburgh")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_It_Wasn_#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Wasn’t Folklore")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_Thinking#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking of Yahweh During a Winter Thaw")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_On_My_Pa#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On My Parents’ Sixty-fifth Wedding Anniversary")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_An_After#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Afternoon Visiting My Mother in Assisted Living")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_The_Days#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Days")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_A_New_Be#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_The_Lett#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_Fractals#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fractals: A Nocturne")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_Searchin#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searching Again for My Father")])]), _vm._v(" "), _c('p', {
    staticClass: "C1557"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/28_2__The_E#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NORMOUS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERY OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUPLES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1559"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_Suite_Fo#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suite For the Turning Year")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_On_Going#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Going with My Wife to Her Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_The_Enor#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enormous Mystery of Couples")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_Theme_an#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theme and Variations")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_Oh_I_Sup#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh I Suppose")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/34_Here_in#page_47",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here in the Time Between")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/35_Practici#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practicing to Walk Like a Heron")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/36_Some_Not#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Notes Taken While the Media Try to Come to Terms with the Life and Death of Michael Jackson")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/37_With#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/38_Morning#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Rounds")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/39_Christma#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas, the Execution of Tookie Williams")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/40_The_Neig#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Neighbors")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/41_William#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Blake’s Hiccoughs")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/42_After_Ta#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Talking It Over")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/43_Just_Bef#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Before He Had Another Panic Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/44_Mid_Octo#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mid-October Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/45_Ron_Howa#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron Howard’s on the Cover of "), _c('em', [_vm._v("AARP")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/46_Take_Lov#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Love for Granted")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/47_My_Wife#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Wife Has Sent Me an Email")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/48_A_Quiet#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quiet Study in Black and Gray")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/49_Speaking#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking Objectively in Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/50_Raking_t#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raking the Duck Weed")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/51_Putting#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting Away the Santas")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/52_Hardship#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hardship in a Nice Place")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/53_The_End#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of This Year")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/54_Have_You#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have You Heard the One About?")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/55_It_s_Apr#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s April and It Should Be Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/56_Epilogue#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "C1557"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/57_Interlud#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERLUDE")]), _vm._v(": “H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KINNY")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRCUS IS IN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWN")]), _vm._v("!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1559"
  }, [_c('span', {
    attrs: {
      "href": "#/html/58_Circus_#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circus: Late Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/59_Outside#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside the Center Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/60_Grouse_o#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grouse of the Circus Boss")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/61_After_th#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Lion Tamer")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/62_Sequins#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sequins")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/63_Daydream#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daydreams of the Catcher of the Queen of the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/64_Suzie#page_94",
      "id": "page_ix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suzie")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/65_The_Deat#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death of the Queen of the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/66_Circus_C#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circus Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/67_The_End#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the Fat Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/68_Death_in#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death in the Dog Act")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/69_The_Chil#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Children of the Lion Tamer")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/70_Roustabo#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roustabout")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/71_Clown#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clown")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/72_The_Ball#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Balloon Man")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/73_Night_on#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Night on the Circus Lot")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/74_Winter_Q#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "C1557"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/75_3__The_H#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDEN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMUTATIONS OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORROW")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1559"
  }, [_c('span', {
    attrs: {
      "href": "#/html/76_The_Two#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Two Chairs in the Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/77_What_Are#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Are You Supposed to Do Anyway?")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/78_Within_t#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Within the Moment of Indefinite Suffering")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/79_The_Hidd#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hidden Permutations of Sorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/80_Listenin#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listening to Chopin in Early Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/81_At_the__#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the “As the Spirit Moves” Poetry Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/82_Instead#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instead of Planting Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/83_The_Man#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Loved Mulch")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/84_After_Mi#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Midnight: Insomnia’s Solace")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/85_A_Man_I#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Man I Know")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/86__Moose_#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Moose. Indian.”")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/87_Several#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Several Old People Are Walking by Our Window")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/88_A_List_o#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A List of Possibilities in an Uncertain Order")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/89_He_Bring#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He Brings Home Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/90_Monet_s#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monet’s “Winter on the Seine, Lavacourt”")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/91_Preludes#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preludes")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/92_Another#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Puppet Show")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/93_The_Reun#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/94_The_Dogs#page_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dogs’ Door Is at the Far End of the House")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/95_The_Arti#page_143",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Artist to the Canvas")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/96_A_Christ#page_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Christmas List for Santa")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/97_But_He_L#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But He Loved His Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/98_A_Cabine#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cabinet of Natural Curiosities")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/99_The_Year#page_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yearling with the Broken Leg")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/100_Another#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Day in Your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/101_The_Knit#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Knitters")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/102_Drinking#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinking Black Tea Early in the Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/103_For_Lenn#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Lenny")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/104_A_Genero#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Generous Welcome")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/105_After_Sp#page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Spending the Morning Baking Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/106_Return_t#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to a Place I Don’t Remember")])]), _vm._v(" "), _c('p', {
    staticClass: "C1563"
  }, [_c('span', {
    attrs: {
      "href": "#/html/107_The_Hero#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heron")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39863056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Contents.vue
// module id = 69
// module chunks = 0